import React from 'react';
import { GlobalDesignDefaultActionPanel } from '../types';
import { SpacingControls } from './components/SpacingControls';

const SpacingStyles: GlobalDesignDefaultActionPanel = (props) => {
  return <SpacingControls hosts={props.hosts} />;
};

export default SpacingStyles;
